import { Box, Stack } from '@mui/system'
import React, { useState } from 'react'
import { Outlet } from 'react-router-dom'
import Sidebar from '../components/Sidebar'
import { createTheme, CssBaseline, ThemeProvider } from "@mui/material";
import { makeStyles} from "@mui/styles";
import {CiDark} from 'react-icons/ci'
import {MdOutlineLightMode} from 'react-icons/md'
import { motion } from 'framer-motion';

const useStyles = makeStyles({
  boxSidebar: {
    position: "absolute",
    left: "0"
  },
  boxPages:{
    width: "100%",
    minHeight: "100vh",
    padding: "10px 15px",
  },
  mobileModeBtn: {
    cursor: "pointer",
    position: "fixed",
    top:"35px",
    left: "0",
    background: "#0066ff",
    color: "#fff",
    padding: "5px 10px 5px 2px",
    width: "32px",
    height: "35px",
    textAlign: "center",
    lineHeight: "35px",
    borderTopRightRadius: "12px",
    borderBottomRightRadius: "12px",
  }
})
function MainLayout() {
  const classes = useStyles()
  const [mode, setMode] = useState(false)

  const theme = createTheme({
    palette: {
      mode: mode ? "dark" : "light",
      primary: {
        main: "#0066ff",
        overlay: "#0066ff88",
      },
      light: {
        main: mode ? "#fff" : "#121212",
        overlay: mode ? "#444" : "#e3e3e3"
      },
      dark: {
        main: "#fff",
      },
      grey: {
        main: mode ? "#999" : "#666",
        dark: mode ? "#444" : "#ccc",
        overlay:  mode ? "#cccccc78" : "#4444447a",
      },
      background: {
        default: mode ? "#333" : "#fff"
      },
    },
  });

  
 
  return (
    <ThemeProvider theme={theme}>
    <CssBaseline />
        <Stack direction="row">
          <Box className={classes.boxSidebar}>
            <Sidebar mode={mode} setMode={setMode} />
          </Box>
          <Box sx={{
            paddingLeft:{xs : "15px", sm: "190px"}
          }} className={classes.boxPages}>
            <Outlet />
          </Box>
          <motion.div initial={{opacity: 0}} animate={{opacity: 1, transition: {duration: .8, delay: 1}}}>          
            <Box onClick={()=> setMode(!mode)} className={classes.mobileModeBtn} sx={{display: {xs : "block", sm: "none"}}}>
              {mode ? <MdOutlineLightMode  size={24}/>: <CiDark size={24}/> }
            </Box>
          </motion.div>

        </Stack>
    </ThemeProvider>

  )
}

export default MainLayout
